/**
 * Normally, "user" refers to an authenticated user.
 */
const USER = 'user';

/**
 * However, sometimes it also refers to an unauthenticated user if the
 * distinction is not relevant at the time.
 */
const USER_OR_GUEST = USER;

/**
 * The term "guest" always refers to an unauthenticated user.
 */
const GUEST = 'guest';

export const LOGIN = 'login';

/**
 * "Logout" refers to the process of voluntarily terminating a user's
 * authenticated session to prevent unauthorized access.
 *
 * @see {@link KICK}
 * @see {@link TIMEOUT}
 * @see {@link LOGIN}
 */
export const LOGOUT = 'logout';

export const KICK = 'kick';

export {USER, GUEST, USER_OR_GUEST};
